import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../environments/environment';
import { Router } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { NationalHolidayDialogComponent } from './national-holiday-dialog/national-holiday-dialog.component';
import moment from 'moment';

// 祝日データ
export interface nationalHoliday {
  holiday: string;
  classification: number;
  note: string;
}

@Component({
  selector: 'app-national-holiday',
  templateUrl: './national-holiday.component.html',
  styleUrls: ['./national-holiday.component.less']
})

export class NationalHolidayComponent implements OnInit {

  // カラム名
  public columnDefs = [
    'day',
    'classification',
    'note',
    'edit',
    'deletion'
  ];

  filterYear = (new Date).getFullYear();
  filterMonth = "";
  filterDay = "";
  filterClassification = "";
  filterMemo = "";

  classifications = [
    {key: "", value: "全て"},
    {key: "0", value: "祝日"},
    {key: "1", value: "祝日(毎年)"},
    {key: "2", value: "全社休日"},
    {key: "3", value: "全社休日(毎年)"}
  ];

  // テーブルデータソース
  public nationalHolidayList = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  constructor(private http: HttpClient, private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    this.getHolidayData();
  }

  /**
   * 認証切れ（401・403）ならログイン画面へ戻す。それ以外のエラーは呼ぶ側で知らせる
   * @param error HTTP エラー
   * @returns ログイン画面へ戻したら true
   */
  isSignOut(error): boolean {
    if (error && (error.status == 401 || error.status == 403)) {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      return true;
    }
    return false;
  }

  /**
   * フィルター変更 イベント
   */
  changeFilter() {
    this.getHolidayData();
  }

  /**
   * 祝祭日データ取得
   */
  getHolidayData() {
    // 年 必須
    if (!this.filterYear) {
      this.nationalHolidayList = new MatTableDataSource([]);
      return;
    }
    this.http.get(
      API_BASE_URL + '/api/v1/nationalHoliday?'
      + "&filterYear="+ encodeURIComponent(String(this.filterYear))
      + "&filterMonth=" + encodeURIComponent(String(this.filterMonth))
      + "&filterDay=" + encodeURIComponent(String(this.filterDay))
      + "&filterClassification=" + encodeURIComponent(this.filterClassification)
      + "&filterMemo=" + encodeURIComponent(this.filterMemo),
      {headers: this.headers}
    )
    .subscribe(res => {
      this.nationalHolidayList = new MatTableDataSource(res as nationalHoliday[]);
    },
    error => {
      if (this.isSignOut(error)) return;
      alert("祝日の取得に失敗しました。");
    });
  }

  /**
   * ダイアログ表示
   * 登録したとき（閉じる値が true）だけ一覧を読み直す。キャンセルでは読み直さない
   * @param event 祝日データ（新規登録のときは無し）
   */
  openDialog(event?) {
    this.dialog.open(NationalHolidayDialogComponent, {
      data: {
        data: event
      }
    }).afterClosed().subscribe(saved => {
      if (saved) {
        this.getHolidayData();
      }
    });
  }

  /**
   * 削除
   * @param event 削除するデータ
   */
  delete(event) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    if (event.note == null) {
      event.note = '';
    }
    if (window.confirm(moment(event.holiday).format('YYYY/MM/DD') + ' ' + event.note + " を削除してよろしいでしょうか？")) {
      this.http.post(
        API_BASE_URL + "/api/v1/nationalHoliday/remove", event, httpOptions
      )
      .subscribe(res => {
        this.getHolidayData();
      },
      error => {
        if (this.isSignOut(error)) return;
        alert("祝日の削除に失敗しました。");
      });
    }
  }

  /**
   * 区分名表示
   * @param event　区分
   * @returns 区分名
   */
  getClassificationName(event: number) {
    var name: string;
    switch (event) {
      case 0:
        name = '祝日'
        break;
      case 1:
        name = '祝日 (毎年)'
        break;
      case 2:
        name = '全社休日'
        break;
      case 3:
        name = '全社休日 (毎年)'
        break;
    }
    return name;
  }
}
